
import { BarChart, BrainCircuit, Users } from "lucide-react";

export const AnalyticsSection = () => {
  const metrics = [
    {
      name: "Episode Engagement",
      percentage: "75%",
      growth: "+24%"
    },
    {
      name: "Audience Growth",
      percentage: "65%",
      growth: "+18%"
    },
    {
      name: "Content Distribution",
      percentage: "85%",
      growth: "+32%"
    },
    {
      name: "Social Media Impact",
      percentage: "60%",
      growth: "+15%"
    }
  ];

  return (
    <section className="py-16 bg-muted">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl font-bold mb-6">Actionable Analytics & Insights</h2>
            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                  <BarChart className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Audience Growth Tracking</h3>
                  <p className="text-muted-foreground">Track listens, engagement, and audience growth across all platforms in one unified dashboard.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                  <BrainCircuit className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">AI-Powered Recommendations</h3>
                  <p className="text-muted-foreground">Receive tailored suggestions to improve content, format, guest selection, and promotion strategy.</p>
                </div>
              </div>
              
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 text-primary flex items-center justify-center">
                  <Users className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold mb-2">Audience Insights</h3>
                  <p className="text-muted-foreground">Understand who's listening, what content resonates most, and where to focus your efforts for maximum growth.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-card p-6 rounded-lg border border-border">
            <h3 className="text-xl font-semibold mb-4">Performance Metrics Dashboard</h3>
            <div className="space-y-6">
              {metrics.map((metric, index) => (
                <div key={index}>
                  <div className="flex justify-between mb-2">
                    <span className="text-sm font-medium">{metric.name}</span>
                    <span className="text-sm text-primary">{metric.growth}</span>
                  </div>
                  <div className="h-2 bg-muted rounded-full overflow-hidden">
                    <div className="h-full bg-primary rounded-full" style={{ width: metric.percentage }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
